module.exports = __webpack_public_path__ + "static/media/app-device.713ef567.png";